import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { getOssConfig } from '@/api/system/upload.js'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { guid } from '@/utils/ruoyi.js'
import AWS from 'aws-sdk'
import { v4 as uuidv4 } from 'uuid'

export default class UploadFileToOSS {
  /**
   * [constructor description]
   * @param  {[Array]} files [chooseImg选中的tempFilePaths、chooseVideo选中的rempFilePath]
   * @param  {[Object]} json  [success每上传成功一张调用 complete全部上传完成调用]
   * @return {[void]}       [description]
   */

  constructor(files, json) {
    if (!Array.isArray(files)) {
      throw new Error('Class UploadFile parameter must be an array')
    }
    this.data = []
    this.fn = json.success
    this.complete = json.finally
    this.files = files
    this.fileLen = this.files.length
    this.curIndex = 0
    // console.log("sdf1111111111111111");
    // notification.info({ message: '上传中' })
    this.upload();
    // this.uploadFileToS3()
  }

  async upload() {
    const token = storage.get(ACCESS_TOKEN)
    // 随机生成一个文件名，并且按照日期归类到二级目录下，否则很容易产生覆盖
    // const dates = new Date()
    // const year = dates.getFullYear()
    // const month = dates.getMonth() + 1
    // const date = dates.getDate()
    // const nowDate = year + '-' + (month < 10 ? `0${month}` : month) + '-' + (date < 10 ? `0${date}` : date)
    // const bmonth = month < 10 ? `0${month}` : month
    // const bdate = date < 10 ? `0${date}` : date
    // getOssConfig().then(res => {
    //   const ossData = res.data
    //   const form = new FormData()
    //   const name = this.files[0].type.split('/')[1]
    //   form.append('key', `${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name)
    //   form.append('policy', ossData.policy)
    //   form.append('OSSAccessKeyId', ossData.accessid)
    //   form.append('success_action_status', '200')
    //   form.append('signature', ossData.signature)
    //   form.append('file', this.files[0])
    //   axios({
    //     url: ossData.uploadUrl,
    //     method: 'post',
    //     headers: {
    //       'Authorization': 'Bearer ' + token,
    //       'Content-Type': 'multipart/form-data',
    //       'Content-Disposition': 'attachment;filename=' + encodeURIComponent(ossData.fileName)
    //     },
    //     data: form
    //   }).then(res => {
    //     console.log('res', res)
    //     if (res.status === 200) {
    //       const url = ossData.resultUrl + `/${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name
    //       this.data.push({
    //         uid: guid(8, 10),
    //         status: 'done',
    //         name: ossData.fileName + '.' + name,
    //         halfUrl: `${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name,
    //         path: url,
    //         url: url,
    //         cover: ''
    //       })
    //       if (this.fn) this.fn(this.data)
    //     } else {
    //       notification.error('上传失败，请重试')
    //     }
    //   }).finally(res => {
    //     console.log('结束', res)
    //     if (this.fn) this.fn(this.data)
    //     this.curIndex++ // 当前文件执行完上传后，开始上传下一张
    //     if (this.curIndex == this.fileLen) { // 当文件传完时，停止调用
    //       this.complete(this.data)
    //     } else { // 若文件还没有传完，则继续调用函数
    //       this.upload()
    //     }
    //   })
    // })


    console.log(getTenCosConfig())
    const tcVod = new TcVod.default({
      getSignature: getTenCosConfig, // 签名数据
      dynamicAccelerate: true, // 开启动态加速
    })

    const uploader = tcVod.upload({
      mediaFile: this.files[0], // 媒体文件（视频或音频或图片），类型为 File
      // fileParallelLimit:10,
      // chunkParallelLimit:10,
      // dynamicAccelerate:true
    })
    let that = this;
    uploader.on('media_progress', function(info) {
      // this.vProgress = info.percent
      // console.log(info)
      if(that.vProgress) that.vProgress(info.percent)
    })

    uploader.done().then(function (doneResult) {
      that.data.push(doneResult.video.url)
      // that.complete(that.data);
      if(that.fn) that.fn(that.data)
      // deal with doneResult
    }).catch(function (err) {
      // deal with error
    })
  }

  async uploadFileToS3() {
    if (!this.files[0]) {
      notification.error('Please select a file first.')
      return
    }
    // 配置 AWS S3 客户端
    AWS.config.update({
      accessKeyId: 'AKIAVIOZFVHN6VLZYRHE',
      secretAccessKey: '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',
      region: 'ap-east-1' // 例如 'us-west-2'
    })
    const s3 = new AWS.S3()
    const name = this.files[0].type.split('/')[1]
    const keyName = uuidv4() + '.' + name
    const params = {
      Bucket: 'dd06-bucket',
      Key: keyName, // 生成唯一的文件名
      ContentType: this.files[0].type,
      Body: this.files[0]
    }
    try {
      const data = await s3.upload(params).promise()
      const url = data.Location
      this.data.push({
        uid: guid(8, 10),
        status: 'done',
        name: keyName,
        halfUrl: keyName,
        path: url,
        url: url,
        cover: ''
      })
      console.log('----------')
      console.log(data)
      console.log(this.data, 'url')
      if (this.fn) this.fn(this.data)
      this.curIndex++ // 当前文件执行完上传后，开始上传下一张
      this.complete(this.data)
    } catch (error) {
      this.uploadStatus = `Error uploading file: ${error.message}`
    }
  }
}
